export { default } from "./Head.js";
